import { c as _c } from "react/compiler-runtime";
import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { theme } from '@cc-shopping/ui/theme';
import { Box, Link, Typography } from '@mui/material';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import { Rating } from 'src/features/product-card/NerdWalletRating/Rating';
import type { MiniProductCardProps } from '..';
type MiniProductCardRatingProps = {
  marketplaceEntity: MiniProductCardProps['marketplaceEntity'];
  blockCTAClick: boolean;
};
export default function MiniProductCardRating(t0) {
  const $ = _c(18);
  const {
    marketplaceEntity,
    blockCTAClick
  } = t0;
  if (!marketplaceEntity.starRating) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      marginBottom: "3px",
      marginTop: "2px"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== marketplaceEntity.starRating) {
    t4 = <Rating value={marketplaceEntity.starRating} size="19px" gap="6px" additionalStyles={t3} />;
    $[3] = marketplaceEntity.starRating;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      whiteSpace: "nowrap"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== blockCTAClick || $[7] !== marketplaceEntity.ctaAnalytics || $[8] !== marketplaceEntity.displayName || $[9] !== marketplaceEntity.name || $[10] !== marketplaceEntity.reviewLink) {
    t6 = !blockCTAClick && marketplaceEntity.reviewLink ? <CtaLink Component={Link} href={marketplaceEntity.reviewLink} target="_blank" sx={{
      position: "relative",
      fontSize: "0.8125rem"
    }} analytics={marketplaceEntity.ctaAnalytics} parameterActions={[]} aria-label={`Read NerdWallet's review of ${marketplaceEntity.displayName || marketplaceEntity.name}`} skipShoppingFinishedEvent={true}>NerdWallet rating</CtaLink> : <Typography sx={{
      fontSize: "13px",
      color: theme.palette.neutral.darker
    }}>NerdWallet rating</Typography>;
    $[6] = blockCTAClick;
    $[7] = marketplaceEntity.ctaAnalytics;
    $[8] = marketplaceEntity.displayName;
    $[9] = marketplaceEntity.name;
    $[10] = marketplaceEntity.reviewLink;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <InfoTooltip text={"NerdWallet's ratings are determined by our editorial team. The scoring formula takes into\n      account the type of card being reviewed (such as cash back, travel or balance transfer) and\n      the card's rates, fees, rewards and other features."} ariaLabel="Rating Details" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <Box sx={t5}>{t6}{t7}</Box>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t8) {
    t9 = <Box sx={t1}><Box sx={t2}>{t4}{t8}</Box></Box>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}